import React, { useEffect, useState } from 'react'

export function Pagination({ total, current, onPageChange, pagesize }) {
    const [data, setData] = useState({ current: 1, total: 0, pagesize: 12 })
    useEffect(() => {
        setData({ total, current, pagesize })
    }, [total, current, onPageChange, pagesize])

    var pagerList = []
    var allPages = Math.floor((data.total + data.pagesize - 1) / data.pagesize)
    var start = Math.max(1, data.current - 2)
    var end = Math.min(data.current + 2, allPages)
    const jumpPrev = (
        <button
            disabled={data.current === 1}
            onClick={() => {
                onPageChange({ current: data.current - 1, prev: data.current })
                setData({ ...data, current: data.current - 1 })
            }}
            className="inline-block border-solid text-lg border-green-700 px-4 py-2 bg-white rounded-md ml-2 mb-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
            صفحه قبل
        </button>
    )
    const jumpNext = (
        <button
            disabled={data.current === allPages}
            onClick={() => {
                onPageChange({ current: data.current + 1, prev: data.current })
                setData({ ...data, current: data.current + 1 })
            }}
            className="inline-block border-solid text-lg border-green-700 px-4 py-2 bg-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
        >
            صفحه بعد
        </button>
    )
    const firstPager = (
        <button
            disabled={data.current === 1}
            onClick={() => {
                onPageChange({ current: 1, prev: data.current })
                setData({ ...data, current: 1 })
            }}
            className="inline-block border-solid text-lg border-green-700 px-4 py-2 w-12 bg-white rounded-md ml-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
            1
        </button>
    )
    const lastPager = (
        <button
            key={i}
            disabled={data.current === allPages}
            onClick={() => {
                onPageChange({ current: allPages, prev: data.current })
                setData({ ...data, current: allPages })
            }}
            className="inline-block border-solid text-lg border-green-700 px-4 py-2 w-12 bg-white rounded-md ml-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
            {allPages}
        </button>
    )

    if (current >= allPages - 2) {
        start = Math.max(allPages - 4, 1)
    }
    if (current <= 3) {
        end = Math.min(5, allPages)
    }

    const callback = function (i) {
        return function () {
            onPageChange({ current: i, prev: data.current })
            setData({ ...data, current: i })
        }
    }
    for (var i = start; i <= end; i++) {
        pagerList.push(
            <button
                key={i}
                disabled={i === current}
                onClick={callback(i)}
                className={`${
                    current === i ? 'bg-blue-400 text-white' : 'bg-white'
                } inline-block border-solid text-lg px-4 py-2 rounded-md ml-2 w-12 disabled:opacity-50 disabled:cursor-not-allowed`}
            >
                {i}
            </button>
        )
    }

    if (start > 2)
        pagerList.unshift(
            <button className="inline-block border-solid text-lg px-4 py-2 w-12 rounded-md ml-2 cursor-default">...</button>
        )
    if (start > 1) pagerList.unshift(firstPager)

    if (end < allPages - 1)
        pagerList.push(
            <button className="inline-block border-solid text-lg px-4 py-2 w-12 rounded-md ml-2 cursor-default">...</button>
        )
    if (end < allPages) pagerList.push(lastPager)

    if (current > 1) {
        pagerList.unshift(jumpPrev)
    }
    if (current < allPages) {
        pagerList.push(jumpNext)
    }

    return (
        <div className="flex mt-2 p-4 flex-col">
            <div className="w-full text-center">{pagerList}</div>
            <div className="w-full text-center mt-2">
                {data.total} محصول یافت شد، صفحه {data.current} از {allPages}
            </div>
        </div>
    )
}
